import React from "react";
import PropTypes from "prop-types";
import { createMuiTheme, TextField, ThemeProvider } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { makeStyles } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles({
  inputTextField: { padding: 1, fontSize: 12 },
  labelTextField: { padding: 1, fontSize: 12, top: -8 },
  shrink: { transform: "translate(0, 9.5px) scale(0.75)" },
});

function EditTextField(props) {
  const classes = useStyles();
  const [beginValue, setBeginValue] = React.useState(props.value ?? "");
  const [value, setValue] = React.useState(props.value ?? "");
  const inputRef = React.useRef(null);
  let InputProps = {};
  if (props.InputProps != null) {
    InputProps = props.InputProps;
  }

  const handleKeyDown = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    if (e.key === "Enter") {
      inputRef.current.blur();
    }
  };

  const getTextField = (write) => (
    <ThemeProvider theme={theme}>
      <TextField
        variant={props.variant ?? "standard"}
        helperText={props.helperText != null && props.helperText}
        multiline={props.multiline != null}
        rowsMax={props.rowsMax != null ? props.rowsMax : 1}
        style={props.style}
        error={value !== beginValue}
        color={"primary"}
        inputRef={inputRef}
        margin={props.margin != null ? props.margin : "none"}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onKeyDown={handleKeyDown}
        disabled={!write || props.disabled}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onBlur={(e) => {
          if (beginValue.toString() !== e.target.value) {
            /// float compared to string
            props.onBlur(e.target.value, setBeginValue, setValue);
          }
        }}
        onFocus={props.onFocus != null ? props.onFocus : null}
        fullWidth={props.fullWidth != null ? props.fullWidth : true}
        size="small"
        inputProps={props.inputProps}
        InputProps={{
          ...InputProps,
          endAdornment: props.endAdornment,
          classes: { input: classes.inputTextField },
        }}
        InputLabelProps={
          props.placeholder
            ? { shrink: true, classes: { root: classes.labelTextField, shrink: classes.shrink } }
            : { classes: { root: classes.labelTextField, shrink: classes.shrink } }
        }
        label={props.label != null && props.label}
        placeholder={props.placeholder != null ? props.placeholder : ""}
        value={value}
        title={props.title}
        type={props.type != null ? props.type : "text"}
        autoFocus={props.autoFocus != null ? props.autoFocus : null}
      />
    </ThemeProvider>
  );

  return props.authorizationField ? (
    <AuthorizationWrapper
      permission={props.authorizationField}
      child={(write) => {
        return getTextField(write);
      }}
    />
  ) : (
    getTextField(true)
  );
}

EditTextField.propTypes = {
  authorizationField: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  inputProps: PropTypes.object,
};

export default EditTextField;
